import { Injectable } from '@angular/core';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  doc,
  setDoc,
  query,
  where,
  getDocs,
  collectionData,
  getDoc, docData
} from "@angular/fire/firestore";
import {ForcedGame, Game} from "../model/broadcast/game";
import {from, Observable, of} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {map, take} from "rxjs/operators";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import Timestamp = firebase.firestore.Timestamp;

@Injectable({
  providedIn: 'root'
})
export class GamesService {

  gamesRef: CollectionReference<Game>;
  forcedGamesRef: CollectionReference<ForcedGame>;
  constructor(
    private afs: Firestore,
    private http: HttpClient,
  ) {
    this.gamesRef = collection(this.afs, 'games') as CollectionReference<Game>;
    this.forcedGamesRef = collection(this.afs, 'forced-games') as CollectionReference<ForcedGame>;
  }

  public forceGameUpdate(gameId: string, leagueId: string) {
    const uid: string = doc(this.forcedGamesRef).id;
    setDoc(doc(this.forcedGamesRef, uid), {gameId, leagueId, uid});
  }

  getGames(): Observable<Game[]> {
    return collectionData(this.gamesRef) as Observable<Game[]>;
  }

  fillMock(gameId: string): void {
    this.http.get('../assets/game-mock.json').pipe(take(1)).subscribe(game => {
      const docRef: DocumentReference<Game> = doc(this.gamesRef, gameId);
      setDoc(docRef, game);
    });

  }

  getGame(gameId: string): Observable<Game> {
    try {
      const docRef = doc(this.gamesRef, gameId);
      return docData(docRef) as Observable<Game>;
    } catch (e) {
      return new Observable<Game>();
    }
  }

  getTournamentGames(tournamentId: string): Observable<Game[]> {
    if (!tournamentId) return of([]);
    return from(getDocs(query(this.gamesRef, where("tournamentId", "==", tournamentId)))).pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data() as Game))
    );
  }

  getUnfinishedGames(): Observable<Game[]> {
    const now = Timestamp.now().toDate(); // Current date
    const startRange = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 10); // 10 days before today
    return from(getDocs(query(this.gamesRef,
        where("finished", "==", false),
        where("scheduled", ">=", Timestamp.fromDate(startRange))
    ))).pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data() as Game))
    );
  }

  getTodayGames(): Observable<Game[]> {
    return this.getGamesForDate(new Date());
  }

  getGamesForDate(date: Date): Observable<Game[]> {
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const end = new Date(start);
    end.setDate(end.getDate() + 1);
    return from(getDocs(query(this.gamesRef,
        where("scheduled", ">=", Timestamp.fromDate(start)),
        where("scheduled", "<", Timestamp.fromDate(end))
    ))).pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data() as Game))
    );
  }
}
